import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import Part from './Part'

export default class Lens extends Part {
	public hbox: number
	public vbox: number
	public centerLine: number

	public ClipOut: TransformNode
	public CrossbarOut: TransformNode

	constructor(parent: TransformNode = null, mirror: boolean = false) {
		super('LENS', parent, mirror)

		this.ClipOut = new TransformNode('CLIP-OUT', this.getScene())
		this.attachmentPoints.set('CLIP-OUT', this.ClipOut)
		this.ClipOut.position.x = this.mirror ? 0.05 : -0.05

		this.ClipOut.parent = this

		this.CrossbarOut = new TransformNode('CROSSBAR-OUT', this.getScene())
		this.attachmentPoints.set('CROSSBAR-OUT', this.CrossbarOut)
		this.CrossbarOut.position.x = this.mirror ? 0.025 : -0.025
		this.CrossbarOut.position.y = 0.015

		this.CrossbarOut.parent = this
	}

	override get filename(): string {
		if (this.config.components.MODEL.design == 'GARNITURE') return null

		if (this.config.components.GROOVE?.color) {
			return `Lenses/Groove/${[this.config.components.MODEL.design, this.config.components.MODEL.size].filter(Boolean).join(' ')}`
		} else {
			return `Lenses/${[this.config.components.MODEL.design, this.config.components.MODEL.size].filter(Boolean).join(' ')}`
		}
	}

	override async load(file?: File) {
		if (this.config.components.MODEL.design == 'GARNITURE') {
			this.container = null
			return
		}
		await super.load(file)
		const mesh = this.container?.meshes.find(x => x.name == 'LENS' || x.name == 'LENS-SURFACE')
		if (mesh) {
			const bounds = mesh.getBoundingInfo()
			const size = bounds.maximum.subtract(bounds.minimum).multiply(new Vector3(1000, 1000, 1000))
			this.hbox = Math.round(size.x)
			this.vbox = size.y
			this.centerLine = (bounds.maximum.y + bounds.minimum.y) / 2
		} else {
			this.hbox = this.vbox = 0
		}
	}

	override getMeshMaterialName(mesh: AbstractMesh): string {
		if (mesh.name == 'LENS' || mesh.name == 'LENS-SURFACE') {
			return this.config.components.LENSES.color
		} else if (mesh.name == 'LENS-EDGE' || mesh.name == 'LENS-NASAL-SLOT' || mesh.name == 'LENS-TEMPORAL-SLOT' || mesh.name == 'LENS-CROSSBAR-SLOT') {
			return this.config.components.LENS_EDGE.color
		} else if (mesh.name == 'LENS-GROOVE') {
			return this.config.components.GROOVE?.color || this.config.components.LENS_EDGE.color
		} else {
			throw (`Unexpected ${this.name} mesh: (${mesh.name})`)
		}
	}
}
